module.exports = __webpack_public_path__ + "static/media/paso-3.791397f6.png";